import { useQuery } from '@tanstack/react-query'
import { getCompanyCompaniesCompanyIdGet } from '@common/config/api/client'
import queryKeyFactory from '../queryKeyFactory'

export default function useGetCompanyById(companyId: string | null) {
  return useQuery({
    queryKey: queryKeyFactory.company(companyId!),
    queryFn: async () => {
      const response = await getCompanyCompaniesCompanyIdGet({
        path: { company_id: companyId! },
        throwOnError: true,
      })
      return response.data
    },
    enabled: !!companyId,
  })
}
